/* =========================================================
   CONFIG — paste your JSONBin credentials here
   ========================================================= */
const JSONBIN_MASTER_KEY    = '$2a$10$vHKzH581j4bh/yt4NKaCjOUPm57jCA.zkhu7QJspIkxQFvz2rkkQu';
const SESSIONS_INDEX_BIN_ID = '6a0873eb250b1311c35c3f70';

// Google Apps Script Web App URL — archives closed sessions to your Sheet
const SHEETS_ARCHIVE_URL = 'https://script.google.com/macros/s/AKfycbydXodzpRUuQusKebNhfstxXcRr1ku2dHHQ_NoNL-H_nAjJ7GBSkkNdpTnxxChfo4Yi/exec';

// URL where the staff cupper file is hosted (used to build share links).
// While testing locally, this can be a file:// URL or relative path.
// For production, set this to e.g. 'https://48e.co/pages/cupping' once deployed.
// Production: staff cupper page lives at /pages/cupping
const CUPPER_URL_BASE = 'https://48e.co/pages/cupping';

const JSONBIN_BASE = 'https://api.jsonbin.io/v3/b';

/* =========================================================
   LOGO
   ========================================================= */
// Logo URL is injected via window.LOGO_URL from the Liquid template
document.getElementById('brandLogo').src = window.LOGO_URL || '';

/* =========================================================
   STATE
   ========================================================= */
const state = {
  mode: 'active',              // active | history | create | share | live
  index: null,                 // { sessions: [...] }
  activeSession: null,         // currently viewing/editing
  draftSession: null,          // session being created
  livePollInterval: null,
  configValid: false
};

const QUADRANTS = {
  purple: { name: 'Purple', color: '#6b3fa0' },
  white:  { name: 'White',  color: '#c8b878' },
  yellow: { name: 'Yellow', color: '#e6a93b' },
  red:    { name: 'Red',    color: '#c8362b' }
};

/* =========================================================
   HELPERS
   ========================================================= */
const $ = (id) => document.getElementById(id);
const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const today = () => new Date().toISOString().slice(0,10);
const newId = () => crypto.randomUUID ? crypto.randomUUID() : 's_' + Date.now() + '_' + Math.random().toString(36).slice(2,7);
const formatDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }).toUpperCase(); }
  catch { return iso; }
};
const formatRelative = (iso) => {
  if (!iso) return '—';
  const then = new Date(iso); const now = new Date();
  const ms = now - then;
  const mins = Math.floor(ms / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return mins + 'm ago';
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return hrs + 'h ago';
  return formatDate(iso);
};

function setStatus(text, kind) {
  $('statusText').textContent = text;
  $('statusPill').classList.remove('connected', 'error');
  if (kind) $('statusPill').classList.add(kind);
}
function setFootStatus(text) { $('footStatus').textContent = text; }

function gradeFor(score) {
  if (score >= 90) return { label: 'Outstanding', specialty: true };
  if (score >= 85) return { label: 'Excellent', specialty: true };
  if (score >= 80) return { label: 'Specialty', specialty: true };
  if (score >= 70) return { label: 'Below Specialty', specialty: false };
  if (score >= 60) return { label: 'Commercial', specialty: false };
  return { label: 'Off-grade', specialty: false };
}

/* =========================================================
   JSONBIN API
   ========================================================= */
function configValid() {
  return JSONBIN_MASTER_KEY && !JSONBIN_MASTER_KEY.includes('__PASTE_')
      && SESSIONS_INDEX_BIN_ID && !SESSIONS_INDEX_BIN_ID.includes('__PASTE_');
}

async function jbCreate(payload, name) {
  const r = await fetch(JSONBIN_BASE, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Master-Key': JSONBIN_MASTER_KEY,
      ...(name ? { 'X-Bin-Name': name } : {}),
      'X-Bin-Private': 'false'   // public bins so cuppers can read without an access key in URL
    },
    body: JSON.stringify(payload)
  });
  if (!r.ok) throw new Error('JSONBin create failed: ' + r.status + ' ' + await r.text());
  const data = await r.json();
  return data.metadata.id;
}

async function jbRead(binId) {
  const r = await fetch(`${JSONBIN_BASE}/${binId}/latest`, {
    method: 'GET',
    headers: { 'X-Master-Key': JSONBIN_MASTER_KEY }
  });
  if (!r.ok) throw new Error('JSONBin read failed: ' + r.status);
  const data = await r.json();
  return data.record;
}

async function jbUpdate(binId, payload) {
  const r = await fetch(`${JSONBIN_BASE}/${binId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-Master-Key': JSONBIN_MASTER_KEY
    },
    body: JSON.stringify(payload)
  });
  if (!r.ok) throw new Error('JSONBin update failed: ' + r.status + ' ' + await r.text());
  return await r.json();
}

/* =========================================================
   INDEX MANAGEMENT
   ========================================================= */
async function loadIndex() {
  if (!configValid()) {
    state.configValid = false;
    $('configNotice').classList.add('show');
    setStatus('Setup required', 'error');
    return null;
  }
  try {
    setStatus('Loading…');
    setFootStatus('Fetching index…');
    const idx = await jbRead(SESSIONS_INDEX_BIN_ID);
    state.index = idx;
    state.configValid = true;
    $('configNotice').classList.remove('show');
    setStatus('Connected', 'connected');
    setFootStatus('Idle');
    renderActiveList();
    renderHistoryList();
    return idx;
  } catch (e) {
    console.error(e);
    setStatus('Connection failed', 'error');
    setFootStatus('Error: ' + e.message);
    state.configValid = false;
    return null;
  }
}

async function addToIndex(sessionMeta) {
  if (!state.index) state.index = { type:'48east-cupping-index', sessions: [] };
  state.index.sessions = state.index.sessions || [];
  state.index.sessions.unshift(sessionMeta);  // newest first
  await jbUpdate(SESSIONS_INDEX_BIN_ID, state.index);
}

async function updateIndexEntry(sessionId, patch) {
  if (!state.index) await loadIndex();
  const idx = state.index.sessions.findIndex(s => s.id === sessionId);
  if (idx >= 0) {
    state.index.sessions[idx] = { ...state.index.sessions[idx], ...patch };
    await jbUpdate(SESSIONS_INDEX_BIN_ID, state.index);
  }
}

/* =========================================================
   SCREEN SWITCHING
   ========================================================= */
function showScreen(mode) {
  state.mode = mode;
  document.querySelectorAll('.screen').forEach(el => el.classList.remove('active'));
  $('screen-' + mode).classList.add('active');
  document.querySelectorAll('.mode-tab').forEach(t => t.classList.toggle('active', t.dataset.mode === mode));
  // Conditional tabs
  $('screen-create');
  document.querySelectorAll('.mode-tab[data-mode]').forEach(t => {
    if (['create','share','live'].includes(t.dataset.mode)) {
      t.style.display = (t.dataset.mode === mode) ? 'inline-flex' : 'none';
    }
  });
  // stop polling unless we're on live
  if (mode !== 'live' && state.livePollInterval) {
    clearInterval(state.livePollInterval);
    state.livePollInterval = null;
  }
}

/* =========================================================
   ACTIVE LIST
   ========================================================= */
function renderActiveList() {
  const list = $('activeList');
  if (!state.index || !state.index.sessions) {
    list.innerHTML = '<div class="history-empty">Index not loaded.</div>';
    return;
  }
  const open = state.index.sessions.filter(s => s.status !== 'closed');
  $('activeCount').textContent = open.length;
  $('activeSubtext').textContent = open.length ? open.length + ' open' : 'None open';

  if (open.length === 0) {
    list.innerHTML = '<div class="history-empty">No active sessions. Click <strong>+ New Session</strong> to begin.</div>';
    return;
  }
  list.innerHTML = '';
  open.forEach(s => {
    const row = document.createElement('div');
    row.className = 'history-row';
    row.innerHTML = `
      <span class="stamp">${formatDate(s.date)}</span>
      <span class="name">${escapeHtml(s.name || 'Untitled')}</span>
      <span class="stats">${s.coffeeCount || 0} coffees · ${s.submissionCount || 0} submissions</span>
      <span class="status open">Open</span>
      <span class="stats">Updated ${formatRelative(s.updatedAt)}</span>
      <div class="actions" style="display:flex;gap:6px;">
        <button class="btn ghost" data-act="open" data-id="${s.id}" data-bin="${s.binId}">Open</button>
        <button class="btn ghost" data-act="share" data-id="${s.id}" data-bin="${s.binId}">Share</button>
      </div>
    `;
    list.appendChild(row);
  });
  list.querySelectorAll('[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.id;
      const bin = btn.dataset.bin;
      const session = state.index.sessions.find(x => x.id === id);
      if (btn.dataset.act === 'open') {
        openLiveSession(bin, session);
      } else if (btn.dataset.act === 'share') {
        openShareScreen(bin, session);
      }
    });
  });
}

function renderHistoryList() {
  const list = $('historyList');
  if (!state.index || !state.index.sessions) {
    list.innerHTML = '<div class="history-empty">Index not loaded.</div>';
    return;
  }
  const closed = state.index.sessions.filter(s => s.status === 'closed');
  $('historyCount').textContent = closed.length;
  if (closed.length === 0) {
    list.innerHTML = '<div class="history-empty">No past sessions yet. Closed sessions will appear here.</div>';
    return;
  }
  list.innerHTML = '';
  closed.forEach(s => {
    const row = document.createElement('div');
    row.className = 'history-row';
    const archiveBadge = s.archived
      ? `<span style="font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:#15803d;">✓ Archived</span>`
      : `<span style="font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:#c0392b;">Not Archived</span>`;
    row.innerHTML = `
      <span class="stamp">${formatDate(s.date)}</span>
      <span class="name">${escapeHtml(s.name || 'Untitled')}</span>
      <span class="stats">${s.coffeeCount || 0} coffees · ${s.submissionCount || 0} submissions · ${archiveBadge}</span>
      <span class="status closed">Closed</span>
      <span class="stats">Closed ${formatRelative(s.closedAt)}</span>
      <div class="actions" style="display:flex;gap:6px;">
        <button class="btn ghost" data-act="view" data-id="${s.id}" data-bin="${s.binId}">View</button>
        <button class="btn ghost" data-act="archive" data-id="${s.id}" data-bin="${s.binId}">${s.archived ? 'Re-Archive' : 'Archive'}</button>
      </div>
    `;
    list.appendChild(row);
  });
  list.querySelectorAll('[data-act="view"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const session = state.index.sessions.find(x => x.id === btn.dataset.id);
      openLiveSession(btn.dataset.bin, session, true);  // readOnly
    });
  });
  list.querySelectorAll('[data-act="archive"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wasArchived = state.index.sessions.find(x => x.id === btn.dataset.id).archived;
      if (wasArchived) {
        if (!confirm('This session has already been archived. Re-archiving will append duplicate rows to your Sheet. Continue?')) return;
      }
      reArchiveSession(btn.dataset.bin);
    });
  });
}

/* =========================================================
   CREATE SESSION
   ========================================================= */
function startCreate() {
  state.draftSession = {
    name: '',
    date: today(),
    host: '',
    location: '',
    notes: '',
    coffees: [],
    blindMode: false
  };
  $('newSessionName').value = '';
  $('newSessionDate').value = today();
  $('newSessionHost').value = '';
  $('newSessionLocation').value = '';
  $('newSessionNotes').value = '';
  renderCoffeeList();
  showScreen('create');
  // start with one empty coffee row so it doesn't look empty
  addCoffee();
}

function addCoffee() {
  state.draftSession.coffees.push({
    id: newId(),
    name: '',
    origin: '',
    originManual: '',
    brew: '',
    use: '',
    useManual: ''
  });
  renderCoffeeList();
}

function removeCoffee(id) {
  state.draftSession.coffees = state.draftSession.coffees.filter(c => c.id !== id);
  renderCoffeeList();
}

const ORIGINS = ['Bolivia','Brazil','Colombia','Ecuador','El Salvador','Ethiopia','Guatemala','Honduras','India','Kenya','Malaysia','Mexico','Nicaragua','Panama','Papua New Guinea','Peru','Rwanda','Timor-Leste','Yemen'];
const BREWS   = ['Espresso','Filter','Pour-over (V60)','Pour-over (Kalita)','Chemex','AeroPress','French Press','Cold Brew','Moka Pot','Cupping Bowl (SCA)','Turkish','Other'];
const USES    = ['SO Espresso','SO Filter','Blend','RESF (Filter)','RESE (Espresso)'];

function renderCoffeeList() {
  const list = $('coffeeList');
  if (state.draftSession.coffees.length === 0) {
    list.innerHTML = '<div class="coffees-empty">Add at least one coffee to begin.</div>';
    $('createSummary').textContent = '0 coffees';
    return;
  }
  list.innerHTML = '';
  state.draftSession.coffees.forEach((c, i) => {
    const row = document.createElement('div');
    row.className = 'coffee-row';
    row.innerHTML = `
      <div class="coffee-cell idx">${String(i+1).padStart(2,'0')}</div>
      <div class="coffee-cell">
        <label>Sample / Coffee Name</label>
        <input data-cid="${c.id}" data-f="name" type="text" value="${escapeHtml(c.name)}" placeholder="e.g. Yirgacheffe G1 Natural">
      </div>
      <div class="coffee-cell">
        <label>Origin</label>
        <select data-cid="${c.id}" data-f="origin">
          <option value="">— Select —</option>
          ${ORIGINS.map(o => `<option value="${o}" ${c.origin===o?'selected':''}>${o}</option>`).join('')}
          <option value="__manual__" ${c.origin==='__manual__'?'selected':''}>Other (manual)…</option>
        </select>
        ${c.origin === '__manual__' ? `<input data-cid="${c.id}" data-f="originManual" type="text" value="${escapeHtml(c.originManual)}" placeholder="Type origin…" style="margin-top:4px;border-bottom:1px dotted var(--orange)">` : ''}
      </div>
      <div class="coffee-cell">
        <label>Brew Method</label>
        <select data-cid="${c.id}" data-f="brew">
          <option value="">— Select —</option>
          ${BREWS.map(b => `<option value="${b}" ${c.brew===b?'selected':''}>${b}</option>`).join('')}
        </select>
      </div>
      <div class="coffee-cell">
        <label>Intended Use</label>
        <select data-cid="${c.id}" data-f="use">
          <option value="">— Select —</option>
          ${USES.map(u => `<option value="${u}" ${c.use===u?'selected':''}>${u}</option>`).join('')}
          <option value="__manual__" ${c.use==='__manual__'?'selected':''}>Other (manual)…</option>
        </select>
        ${c.use === '__manual__' ? `<input data-cid="${c.id}" data-f="useManual" type="text" value="${escapeHtml(c.useManual)}" placeholder="Type use…" style="margin-top:4px;border-bottom:1px dotted var(--orange)">` : ''}
      </div>
      <div class="coffee-cell del">
        <button class="del-btn" data-rm="${c.id}" title="Remove">×</button>
      </div>
    `;
    list.appendChild(row);
  });
  $('createSummary').textContent = state.draftSession.coffees.length + ' coffee' + (state.draftSession.coffees.length === 1 ? '' : 's');

  // bind events
  list.querySelectorAll('[data-cid]').forEach(input => {
    const handler = () => {
      const c = state.draftSession.coffees.find(x => x.id === input.dataset.cid);
      if (!c) return;
      c[input.dataset.f] = input.value;
      if (input.dataset.f === 'origin' || input.dataset.f === 'use') {
        renderCoffeeList();  // re-render to show/hide manual field
      }
    };
    input.addEventListener('input', handler);
    input.addEventListener('change', handler);
  });
  list.querySelectorAll('[data-rm]').forEach(btn => {
    btn.addEventListener('click', () => removeCoffee(btn.dataset.rm));
  });
}

async function publishSession() {
  if (!state.configValid) {
    alert('JSONBin not configured. Please paste your credentials in the file first.');
    return;
  }
  const draft = state.draftSession;
  draft.name = $('newSessionName').value.trim();
  draft.date = $('newSessionDate').value || today();
  draft.host = $('newSessionHost').value.trim();
  draft.location = $('newSessionLocation').value.trim();
  draft.notes = $('newSessionNotes').value.trim();

  if (!draft.name) { alert('Session name is required.'); return; }
  if (draft.coffees.length === 0) { alert('Add at least one coffee.'); return; }
  const blankCoffees = draft.coffees.filter(c => !c.name.trim());
  if (blankCoffees.length > 0) { alert('All coffees need a name.'); return; }

  const btn = $('publishSessionBtn');
  btn.disabled = true;
  btn.innerHTML = '<span class="loader"></span> Publishing…';
  setStatus('Creating session…');

  try {
    const sessionId = newId();
    const sessionData = {
      type: '48east-cupping-session',
      id: sessionId,
      name: draft.name,
      date: draft.date,
      host: draft.host,
      location: draft.location,
      notes: draft.notes,
      coffees: draft.coffees,
      status: 'open',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      submissions: []
    };

    // Create the session bin (public read so cuppers can fetch without master key)
    const binId = await jbCreate(sessionData, `48east-cupping-${draft.date}-${draft.name.slice(0,30)}`);

    // Add to index
    await addToIndex({
      id: sessionId,
      binId,
      name: draft.name,
      date: draft.date,
      host: draft.host,
      location: draft.location,
      coffeeCount: draft.coffees.length,
      submissionCount: 0,
      status: 'open',
      createdAt: sessionData.createdAt,
      updatedAt: sessionData.updatedAt
    });

    setStatus('Connected', 'connected');
    btn.disabled = false;
    btn.textContent = 'Publish Session';

    // Pass to share screen
    openShareScreen(binId, { ...sessionData, binId });
  } catch (e) {
    console.error(e);
    setStatus('Publish failed', 'error');
    alert('Failed to publish: ' + e.message);
    btn.disabled = false;
    btn.textContent = 'Publish Session';
  }
}

/* =========================================================
   SHARE SCREEN
   ========================================================= */
function buildShareUrl(binId) {
  return `${CUPPER_URL_BASE}?s=${binId}`;
}

function openShareScreen(binId, sessionMeta) {
  state.activeSession = { binId, meta: sessionMeta };
  $('shareSessionName').textContent = sessionMeta.name || 'Untitled Session';
  const url = buildShareUrl(binId);
  $('shareUrl').textContent = url;
  $('shareUrl').dataset.url = url;

  const summary = $('shareSummaryBody');
  summary.innerHTML = `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;font-size:13px;line-height:1.6;">
      <div><strong style="font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--ink-50);">Date</strong><br>${formatDate(sessionMeta.date)}</div>
      <div><strong style="font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--ink-50);">Host</strong><br>${escapeHtml(sessionMeta.host || '—')}</div>
      <div><strong style="font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--ink-50);">Location</strong><br>${escapeHtml(sessionMeta.location || '—')}</div>
      <div><strong style="font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--ink-50);">Coffees</strong><br>${(sessionMeta.coffees || []).length}</div>
    </div>
    ${(sessionMeta.coffees && sessionMeta.coffees.length) ? `
      <div style="margin-top:18px;padding-top:14px;border-top:1px solid var(--line);">
        <strong style="font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:var(--ink-50);">Coffee List</strong>
        <ol style="margin-top:8px;padding-left:18px;font-size:13px;line-height:1.8;">
          ${sessionMeta.coffees.map(c => `<li><strong>${escapeHtml(c.name)}</strong>${c.origin ? ' · ' + escapeHtml(c.origin === '__manual__' ? c.originManual : c.origin) : ''}${c.brew ? ' · ' + escapeHtml(c.brew) : ''}</li>`).join('')}
        </ol>
      </div>` : ''}
  `;
  showScreen('share');
}

function copyShareUrl() {
  const url = $('shareUrl').dataset.url;
  navigator.clipboard.writeText(url).then(() => {
    const btn = $('copyUrlBtn');
    const orig = btn.textContent;
    btn.textContent = '✓ Copied';
    setTimeout(() => btn.textContent = orig, 1500);
  }).catch(() => {
    prompt('Copy this URL:', url);
  });
}

function shareVia(method) {
  const url = $('shareUrl').dataset.url;
  const meta = state.activeSession.meta;
  const msg = `48 East Cupping — ${meta.name}\nPlease join: ${url}`;
  if (method === 'whatsapp') {
    window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
  } else if (method === 'email') {
    window.open(`mailto:?subject=${encodeURIComponent('Cupping Session: ' + meta.name)}&body=${encodeURIComponent(msg)}`);
  } else if (method === 'sms') {
    window.open(`sms:?body=${encodeURIComponent(msg)}`);
  }
}

/* =========================================================
   LIVE RESULTS
   ========================================================= */
async function openLiveSession(binId, meta, readOnly) {
  state.activeSession = { binId, meta, readOnly: !!readOnly };
  $('liveTitle').textContent = meta.name || 'Session';
  $('liveEyebrow').textContent = `${formatDate(meta.date)} · ${meta.host || '—'} · ${meta.coffeeCount || (meta.coffees || []).length} coffees`;
  $('liveCloseSessionBtn').style.display = readOnly ? 'none' : '';
  $('liveStatus').textContent = readOnly ? 'Read-only (closed)' : 'Polling every 10s';

  showScreen('live');
  await refreshLiveResults();

  if (!readOnly) {
    if (state.livePollInterval) clearInterval(state.livePollInterval);
    state.livePollInterval = setInterval(refreshLiveResults, 10000);
  }
}

async function refreshLiveResults() {
  if (!state.activeSession) return;
  try {
    setFootStatus('Refreshing live results…');
    const session = await jbRead(state.activeSession.binId);
    state.activeSession.data = session;
    renderLiveResults(session);
    setFootStatus('Last refresh ' + new Date().toLocaleTimeString());
  } catch (e) {
    console.error(e);
    setFootStatus('Refresh failed: ' + e.message);
  }
}

function renderLiveResults(session) {
  const subs = session.submissions || [];

  // Unique cuppers list, with their progress (n submissions / total coffees)
  const cuppersMap = {};
  subs.forEach(s => {
    if (!cuppersMap[s.cupperName]) {
      cuppersMap[s.cupperName] = { name: s.cupperName, count: 0, latest: null };
    }
    cuppersMap[s.cupperName].count++;
    cuppersMap[s.cupperName].latest = s.submittedAt;
  });
  const cuppers = Object.values(cuppersMap).sort((a,b) => b.count - a.count);
  $('cupperCountBadge').textContent = cuppers.length;

  const cuppersList = $('cuppersList');
  if (cuppers.length === 0) {
    cuppersList.innerHTML = '<div class="cuppers-empty">Waiting for cuppers…</div>';
  } else {
    cuppersList.innerHTML = '';
    cuppers.forEach(c => {
      const total = session.coffees.length;
      const pill = document.createElement('div');
      pill.className = 'cupper-pill';
      pill.innerHTML = `
        <div>
          <div class="name">${escapeHtml(c.name)}</div>
          <div class="meta">${formatRelative(c.latest)}</div>
        </div>
        <span class="progress">${c.count}/${total}</span>
      `;
      cuppersList.appendChild(pill);
    });
  }

  // Group submissions by coffeeId
  const byCoffee = {};
  subs.forEach(s => {
    if (!byCoffee[s.coffeeId]) byCoffee[s.coffeeId] = [];
    byCoffee[s.coffeeId].push(s);
  });

  // Render results
  const tbody = $('resultsTable');
  if (session.coffees.length === 0) {
    tbody.innerHTML = '<tr><td colspan="6" class="empty-results">No coffees defined.</td></tr>';
    return;
  }
  tbody.innerHTML = '';
  session.coffees.forEach((coffee, i) => {
    const coffeeSubs = byCoffee[coffee.id] || [];
    const scores = coffeeSubs.map(s => s.score).filter(n => typeof n === 'number');
    let avg = 0, spread = 0;
    if (scores.length > 0) {
      avg = scores.reduce((a,b) => a+b, 0) / scores.length;
      const min = Math.min(...scores);
      const max = Math.max(...scores);
      spread = max - min;
    }
    const g = gradeFor(avg);

    // Descriptor consensus: tally descriptor names across all submissions for this coffee
    const descCounts = {};
    coffeeSubs.forEach(s => {
      (s.descriptors || []).forEach(d => {
        const key = d.name + '|' + d.quad;
        if (!descCounts[key]) descCounts[key] = { name: d.name, quad: d.quad, count: 0 };
        descCounts[key].count++;
      });
    });
    const topDescriptors = Object.values(descCounts)
      .sort((a,b) => b.count - a.count)
      .slice(0, 10);

    const originDisplay = coffee.origin === '__manual__' ? coffee.originManual : (coffee.origin || '');
    const useDisplay = coffee.use === '__manual__' ? coffee.useManual : (coffee.use || '');

    const tr = document.createElement('tr');
    tr.innerHTML = `
      <td class="num">${String(i+1).padStart(2,'0')}</td>
      <td>
        <div class="sample-name">${escapeHtml(coffee.name)}</div>
        <div class="sample-meta">${escapeHtml(originDisplay || '—')}${coffee.brew ? ' · ' + escapeHtml(coffee.brew) : ''}${useDisplay ? ' · ' + escapeHtml(useDisplay) : ''}</div>
      </td>
      <td class="num">
        ${scores.length > 0
          ? `<span class="avg-score ${g.specialty ? 'specialty' : ''}">${avg.toFixed(1)}</span><br><span style="font-size:10px;color:var(--ink-50);letter-spacing:0.12em;text-transform:uppercase;">${g.label}</span>`
          : '<span style="color:var(--ink-30);font-style:italic;font-family:var(--font-en);">—</span>'}
      </td>
      <td class="num">
        ${scores.length > 0
          ? `<span class="spread">±${(spread/2).toFixed(1)}<br>n=${scores.length}</span>`
          : '<span style="color:var(--ink-30);">—</span>'}
      </td>
      <td>
        <div class="per-cupper">
          ${coffeeSubs.length === 0
            ? '<span style="color:var(--ink-30);font-style:italic;font-size:11px;">No submissions yet</span>'
            : coffeeSubs.map(s => {
                const sg = gradeFor(s.score);
                return `<span class="cupper-score-chip ${sg.specialty ? 'specialty' : ''}"><span class="cn">${escapeHtml(s.cupperName)}</span><span class="cv">${s.score.toFixed(1)}${s.isManualScore ? ' <span style="color:var(--orange);font-size:9px;letter-spacing:0.1em;font-weight:700;">M</span>' : ''}</span></span>`;
              }).join('')}
        </div>
      </td>
      <td>
        <div class="descriptors-cell">
          ${topDescriptors.length === 0
            ? '<span style="color:var(--ink-30);font-style:italic;font-size:11px;">—</span>'
            : topDescriptors.map(d => `<span class="descriptor-chip q-${d.quad}">${escapeHtml(d.name)}<span class="ct">×${d.count}</span></span>`).join('')}
        </div>
      </td>
    `;
    tbody.appendChild(tr);
  });

  // Update index entry with current counts if it changed
  const submissionCount = subs.length;
  const idxEntry = state.index && state.index.sessions.find(s => s.binId === state.activeSession.binId);
  if (idxEntry && idxEntry.submissionCount !== submissionCount) {
    idxEntry.submissionCount = submissionCount;
    idxEntry.updatedAt = new Date().toISOString();
    // best-effort update
    jbUpdate(SESSIONS_INDEX_BIN_ID, state.index).catch(e => console.warn('Index update failed:', e));
  }
}

async function archiveToSheets(session) {
  if (!SHEETS_ARCHIVE_URL || SHEETS_ARCHIVE_URL.includes('__PASTE')) {
    return { ok: false, error: 'Sheets URL not configured' };
  }
  try {
    // Apps Script Web Apps require text/plain or application/x-www-form-urlencoded
    // to avoid a CORS preflight; we send a stringified JSON body with text/plain.
    const res = await fetch(SHEETS_ARCHIVE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ type: 'archive-session', session })
    });
    const data = await res.json();
    return data;
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

async function closeSession() {
  if (!state.activeSession) return;
  if (!confirm('Close this session? Cuppers will no longer be able to submit scores. This action cannot be undone.\n\nClosing will also archive the session to your Google Sheet.')) return;
  try {
    setStatus('Closing session…');
    const session = await jbRead(state.activeSession.binId);
    session.status = 'closed';
    session.closedAt = new Date().toISOString();
    await jbUpdate(state.activeSession.binId, session);

    // Archive to Google Sheets (best-effort)
    setStatus('Archiving to Sheets…');
    setFootStatus('Archiving…');
    const archiveResult = await archiveToSheets(session);

    await updateIndexEntry(session.id, {
      status: 'closed',
      closedAt: session.closedAt,
      archived: !!archiveResult.ok,
      archivedRows: archiveResult.archived || 0
    });

    setStatus('Connected', 'connected');
    setFootStatus('Idle');

    if (archiveResult.ok) {
      alert(`Session closed.\n\n✓ Archived ${archiveResult.archived || 0} submission${archiveResult.archived === 1 ? '' : 's'} to Google Sheets.`);
    } else {
      alert(`Session closed.\n\n⚠ Sheets archive failed: ${archiveResult.error || 'unknown error'}\n\nThe session data is still saved in JSONBin. You can re-archive later from the History tab.`);
    }

    if (state.livePollInterval) { clearInterval(state.livePollInterval); state.livePollInterval = null; }
    showScreen('history');
  } catch (e) {
    setStatus('Close failed', 'error');
    alert('Failed to close session: ' + e.message);
  }
}

async function reArchiveSession(binId) {
  try {
    setStatus('Re-archiving…');
    setFootStatus('Re-archiving to Sheets…');
    const session = await jbRead(binId);
    const result = await archiveToSheets(session);
    setStatus('Connected', 'connected');
    setFootStatus('Idle');
    if (result.ok) {
      await updateIndexEntry(session.id, { archived: true, archivedRows: result.archived || 0 });
      alert(`✓ Archived ${result.archived || 0} submission${result.archived === 1 ? '' : 's'} to Google Sheets.\n\nNote: this appends rows. If you re-archive a session that was already archived, you'll get duplicate rows in your Sheet — delete the old rows manually if needed.`);
      renderHistoryList();
    } else {
      alert('Archive failed: ' + (result.error || 'unknown error'));
    }
  } catch (e) {
    setStatus('Archive failed', 'error');
    alert('Failed: ' + e.message);
  }
}

/* =========================================================
   EXPORTS
   ========================================================= */
function escapeCSV(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) return '"' + s.replace(/"/g,'""') + '"';
  return s;
}

function exportLiveCSV() {
  const session = state.activeSession && state.activeSession.data;
  if (!session) { alert('No data loaded yet.'); return; }

  // Two sections: per-submission detail, then aggregated per-coffee summary
  const headers1 = [
    'Section','Sample #','Sample','Origin','Brew','Intended Use',
    'Cupper','Overall Impression','Final Score','Score Type','Grade','Descriptors','Cupper Notes','Submitted At'
  ];
  const headers2 = [
    'Section','Sample #','Sample','Origin','Brew','Intended Use',
    'Avg Score','Spread','n Submissions','Grade','Top Descriptors'
  ];

  const lines = [];
  lines.push('# 48 East · Cupping Session');
  lines.push('# Session: ' + session.name);
  lines.push('# Date: ' + session.date);
  lines.push('# Host: ' + session.host);
  lines.push('# Location: ' + session.location);
  lines.push('');
  lines.push(headers1.join(','));

  const subs = session.submissions || [];
  session.coffees.forEach((coffee, i) => {
    const originDisplay = coffee.origin === '__manual__' ? coffee.originManual : coffee.origin;
    const useDisplay = coffee.use === '__manual__' ? coffee.useManual : coffee.use;
    const coffeeSubs = subs.filter(s => s.coffeeId === coffee.id);
    if (coffeeSubs.length === 0) {
      lines.push(['Submission', i+1, coffee.name, originDisplay, coffee.brew, useDisplay, '—', '—', '—', '—', '—', '', '', ''].map(escapeCSV).join(','));
    } else {
      coffeeSubs.forEach(s => {
        const g = gradeFor(s.score);
        const desc = (s.descriptors || []).map(d => `${d.name} (i:${d.intensity || 3})`).join(' | ');
        lines.push([
          'Submission', i+1, coffee.name, originDisplay, coffee.brew, useDisplay,
          s.cupperName, s.impression, s.score.toFixed(1),
          (s.isManualScore ? 'Manual Override' : 'Computed'),
          g.label, desc, s.cupperNotes || '', s.submittedAt
        ].map(escapeCSV).join(','));
      });
    }
  });

  lines.push('');
  lines.push(headers2.join(','));
  session.coffees.forEach((coffee, i) => {
    const originDisplay = coffee.origin === '__manual__' ? coffee.originManual : coffee.origin;
    const useDisplay = coffee.use === '__manual__' ? coffee.useManual : coffee.use;
    const coffeeSubs = subs.filter(s => s.coffeeId === coffee.id);
    const scores = coffeeSubs.map(s => s.score);
    let avg = 0, spread = 0;
    if (scores.length > 0) {
      avg = scores.reduce((a,b)=>a+b,0) / scores.length;
      spread = Math.max(...scores) - Math.min(...scores);
    }
    const g = gradeFor(avg);
    const counts = {};
    coffeeSubs.forEach(s => (s.descriptors || []).forEach(d => {
      counts[d.name] = (counts[d.name] || 0) + 1;
    }));
    const topDesc = Object.entries(counts).sort((a,b)=>b[1]-a[1]).slice(0,8)
      .map(([n,c]) => `${n} ×${c}`).join(' | ');
    lines.push([
      'Aggregate', i+1, coffee.name, originDisplay, coffee.brew, useDisplay,
      scores.length ? avg.toFixed(1) : '—',
      scores.length ? spread.toFixed(1) : '—',
      coffeeSubs.length,
      scores.length ? g.label : '—',
      topDesc
    ].map(escapeCSV).join(','));
  });

  const blob = new Blob(["\uFEFF" + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const slug = (session.name || 'session').replace(/[^a-z0-9]+/gi,'-').toLowerCase();
  a.href = url;
  a.download = `48east-cupping-${session.date}-${slug}.csv`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function exportLivePDF() {
  // Browser print is the cleanest PDF path without extra libs.
  // We open a printable view in a new window with just the results, then trigger print.
  const session = state.activeSession && state.activeSession.data;
  if (!session) { alert('No data loaded yet.'); return; }
  const subs = session.submissions || [];

  const rows = session.coffees.map((coffee, i) => {
    const originDisplay = coffee.origin === '__manual__' ? coffee.originManual : coffee.origin;
    const useDisplay = coffee.use === '__manual__' ? coffee.useManual : coffee.use;
    const coffeeSubs = subs.filter(s => s.coffeeId === coffee.id);
    const scores = coffeeSubs.map(s => s.score);
    let avg = 0, spread = 0;
    if (scores.length > 0) {
      avg = scores.reduce((a,b)=>a+b,0) / scores.length;
      spread = Math.max(...scores) - Math.min(...scores);
    }
    const g = gradeFor(avg);
    const counts = {};
    coffeeSubs.forEach(s => (s.descriptors || []).forEach(d => {
      const key = d.name + '|' + d.quad;
      if (!counts[key]) counts[key] = { name: d.name, quad: d.quad, count: 0 };
      counts[key].count++;
    }));
    const topDesc = Object.values(counts).sort((a,b)=>b.count-a.count).slice(0,10);

    return `
      <div class="pdf-coffee">
        <div class="pdf-coffee-head">
          <span class="pdf-idx">${String(i+1).padStart(2,'0')}</span>
          <div class="pdf-coffee-name">
            <h3>${escapeHtml(coffee.name)}</h3>
            <div class="pdf-meta">${escapeHtml(originDisplay || '—')}${coffee.brew ? ' · ' + escapeHtml(coffee.brew) : ''}${useDisplay ? ' · ' + escapeHtml(useDisplay) : ''}</div>
          </div>
          <div class="pdf-avg ${g.specialty ? 'specialty' : ''}">
            <div class="pdf-avg-num">${scores.length ? avg.toFixed(1) : '—'}</div>
            <div class="pdf-avg-grade">${scores.length ? g.label : 'No submissions'}</div>
            ${scores.length ? `<div class="pdf-avg-spread">±${(spread/2).toFixed(1)} · n=${scores.length}</div>` : ''}
          </div>
        </div>
        ${coffeeSubs.length ? `
          <div class="pdf-cuppers">
            <strong>Per-cupper scores:</strong>
            ${coffeeSubs.map(s => `<span class="pdf-chip">${escapeHtml(s.cupperName)}: <b>${s.score.toFixed(1)}</b></span>`).join('')}
          </div>` : ''}
        ${topDesc.length ? `
          <div class="pdf-desc">
            <strong>Consensus descriptors:</strong>
            ${topDesc.map(d => `<span class="pdf-tag q-${d.quad}">${escapeHtml(d.name)} ×${d.count}</span>`).join('')}
          </div>` : ''}
      </div>
    `;
  }).join('');

  const html = `
<!DOCTYPE html><html><head><meta charset="utf-8"><title>${escapeHtml(session.name)} — 48 East Cupping Report</title>
<style>
  body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: #000; padding: 40px; max-width: 800px; margin: 0 auto; }
  h1 { font-size: 28px; margin: 0 0 6px; letter-spacing: -0.01em; }
  .meta { font-size: 12px; color: #555; letter-spacing: 0.04em; margin-bottom: 24px; padding-bottom: 14px; border-bottom: 2px solid #000; }
  .pdf-coffee { padding: 16px 0; border-bottom: 1px solid #ddd; page-break-inside: avoid; }
  .pdf-coffee-head { display: flex; align-items: center; gap: 16px; }
  .pdf-idx { font-family: 'Courier New', monospace; color: #888; font-size: 14px; min-width: 28px; }
  .pdf-coffee-name { flex: 1; }
  .pdf-coffee-name h3 { font-size: 16px; margin: 0; font-weight: 500; }
  .pdf-meta { font-size: 11px; color: #666; letter-spacing: 0.03em; margin-top: 2px; }
  .pdf-avg { text-align: right; }
  .pdf-avg-num { font-size: 28px; font-weight: 500; letter-spacing: -0.02em; font-family: 'Helvetica Neue', sans-serif; }
  .pdf-avg.specialty .pdf-avg-num { color: #FF6C0E; }
  .pdf-avg-grade { font-size: 10px; letter-spacing: 0.18em; text-transform: uppercase; color: #555; margin-top: 2px; }
  .pdf-avg.specialty .pdf-avg-grade { color: #FF6C0E; }
  .pdf-avg-spread { font-family: 'Courier New', monospace; font-size: 10px; color: #888; margin-top: 2px; }
  .pdf-cuppers, .pdf-desc { font-size: 11px; margin-top: 10px; line-height: 1.8; padding-left: 44px; }
  .pdf-cuppers strong, .pdf-desc strong { letter-spacing: 0.1em; text-transform: uppercase; font-size: 9px; color: #555; margin-right: 6px; }
  .pdf-chip { display: inline-block; background: #f0ece4; padding: 2px 7px; margin-right: 4px; border-radius: 2px; }
  .pdf-tag { display: inline-block; padding: 2px 7px; margin-right: 4px; border-radius: 2px; color: white; font-size: 10px; }
  .pdf-tag.q-purple { background: #6b3fa0; }
  .pdf-tag.q-white { background: #c8b878; color: #000; }
  .pdf-tag.q-yellow { background: #e6a93b; color: #000; }
  .pdf-tag.q-red { background: #c8362b; }
  .pdf-foot { margin-top: 30px; padding-top: 14px; border-top: 1px solid #ddd; font-size: 10px; color: #888; letter-spacing: 0.12em; text-transform: uppercase; }
  @media print { body { padding: 24px; } }
</style></head><body>
  <h1>${escapeHtml(session.name)}</h1>
  <div class="meta">
    ${formatDate(session.date)} &nbsp;·&nbsp;
    Host: ${escapeHtml(session.host || '—')} &nbsp;·&nbsp;
    Location: ${escapeHtml(session.location || '—')} &nbsp;·&nbsp;
    ${session.coffees.length} coffees · ${(session.submissions || []).length} submissions
  </div>
  ${rows}
  <div class="pdf-foot">48 East · Cupping Session Report · ${session.status === 'closed' ? 'Closed ' + formatDate(session.closedAt) : 'Open'}</div>
  <script>window.onload = () => setTimeout(() => window.print(), 300);<\/script>
</body></html>`;

  const w = window.open('', '_blank');
  w.document.open();
  w.document.write(html);
  w.document.close();
}

/* =========================================================
   INIT
   ========================================================= */
function bindEvents() {
  document.querySelectorAll('.mode-tab[data-mode]').forEach(t => {
    t.addEventListener('click', () => {
      const m = t.dataset.mode;
      if (['active','history'].includes(m)) showScreen(m);
    });
  });
  $('refreshBtn').addEventListener('click', loadIndex);
  $('newSessionBtn').addEventListener('click', startCreate);
  $('cancelCreateBtn').addEventListener('click', () => showScreen('active'));
  $('cancelCreateBtn2').addEventListener('click', () => showScreen('active'));
  $('addCoffeeBtn').addEventListener('click', addCoffee);
  $('publishSessionBtn').addEventListener('click', publishSession);
  $('copyUrlBtn').addEventListener('click', copyShareUrl);
  $('shareWhatsappBtn').addEventListener('click', () => shareVia('whatsapp'));
  $('shareEmailBtn').addEventListener('click', () => shareVia('email'));
  $('shareSmsBtn').addEventListener('click', () => shareVia('sms'));
  $('goLiveBtn').addEventListener('click', () => {
    openLiveSession(state.activeSession.binId, state.activeSession.meta);
  });
  $('liveBackBtn').addEventListener('click', () => showScreen('active'));
  $('liveShareBtn').addEventListener('click', () => {
    openShareScreen(state.activeSession.binId, state.activeSession.data || state.activeSession.meta);
  });
  $('liveExportCsvBtn').addEventListener('click', exportLiveCSV);
  $('liveExportPdfBtn').addEventListener('click', exportLivePDF);
  $('liveCloseSessionBtn').addEventListener('click', closeSession);
}

bindEvents();
loadIndex();